import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Token } from '@uniswap/sdk-core';
import axios from 'axios';
import _ from 'lodash';
import { log } from '../util/log';
import { metric, MetricLoggerUnit } from '../util/metric';
export var CachingTokenListProvider = /*#__PURE__*/function () {
  /**
   * Creates an instance of CachingTokenListProvider.
   * Token metadata (e.g. symbol and decimals) generally don't change so can be cached indefinitely.
   *
   * @param chainId The chain id to use.
   * @param tokenList The token list to get the tokens from.
   * @param tokenCache Cache instance to hold cached tokens.
   */
  function CachingTokenListProvider(chainId, tokenList, tokenCache) {
    var _this = this;

    _classCallCheck(this, CachingTokenListProvider);

    this.tokenCache = tokenCache;

    this.CACHE_KEY = function (tokenInfo) {
      return "token-list-token-".concat(_this.chainId, "/").concat(_this.tokenList.name, "/").concat(_this.tokenList.timestamp, "/").concat(_this.tokenList.version, "/").concat(tokenInfo.address.toLowerCase(), "/").concat(tokenInfo.decimals, "/").concat(tokenInfo.symbol, "/").concat(tokenInfo.name);
    };

    this.chainId = chainId;
    this.tokenList = tokenList;
    this.chainToTokenInfos = _.reduce(this.tokenList.tokens, function (result, tokenInfo) {
      var chainId = tokenInfo.chainId.toString();

      if (!result[chainId]) {
        result[chainId] = [];
      }

      result[chainId].push(tokenInfo);
      return result;
    }, {});
    this.chainSymbolToTokenInfo = _.mapValues(this.chainToTokenInfos, function (tokenInfos) {
      return _.keyBy(tokenInfos, 'symbol');
    });
    this.chainAddressToTokenInfo = _.mapValues(this.chainToTokenInfos, function (tokenInfos) {
      return _.keyBy(tokenInfos, function (tokenInfo) {
        return tokenInfo.address.toLowerCase();
      });
    });
  }

  _createClass(CachingTokenListProvider, [{
    key: "getTokens",
    value: function () {
      var _getTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_addresses) {
        var addressToToken, symbolToToken, _iterator, _step, address, token;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                addressToToken = {};
                symbolToToken = {};
                _iterator = _createForOfIteratorHelper(_addresses);
                _context.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 18;
                  break;
                }

                address = _step.value;
                _context.next = 9;
                return this.getTokenByAddress(address);

              case 9:
                token = _context.sent;

                if (token) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("continue", 16);

              case 12:
                addressToToken[address.toLowerCase()] = token;

                if (token.symbol) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("continue", 16);

              case 15:
                symbolToToken[token.symbol.toLowerCase()] = token;

              case 16:
                _context.next = 5;
                break;

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](3);

                _iterator.e(_context.t0);

              case 23:
                _context.prev = 23;

                _iterator.f();

                return _context.finish(23);

              case 26:
                return _context.abrupt("return", {
                  getTokenByAddress: function getTokenByAddress(address) {
                    return addressToToken[address.toLowerCase()];
                  },
                  getTokenBySymbol: function getTokenBySymbol(symbol) {
                    return symbolToToken[symbol.toLowerCase()];
                  },
                  getAllTokens: function getAllTokens() {
                    return Object.values(addressToToken);
                  }
                });

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 20, 23, 26]]);
      }));

      function getTokens(_x) {
        return _getTokens.apply(this, arguments);
      }

      return getTokens;
    }()
  }, {
    key: "getTokenBySymbol",
    value: function () {
      var _getTokenBySymbol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_symbol) {
        var symbol, tokenInfo, token;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                symbol = _symbol; // We consider ETH as a regular ERC20 Token throughout this package. We don't use the NativeCurrency object from the sdk.
                // When we build the calldata for swapping we insert wrapping/unwrapping as needed.

                if (_symbol == 'ETH') {
                  symbol = 'WETH';
                }

                if (this.chainSymbolToTokenInfo[this.chainId.toString()]) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", undefined);

              case 4:
                tokenInfo = this.chainSymbolToTokenInfo[this.chainId.toString()][symbol];

                if (tokenInfo) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", undefined);

              case 7:
                _context2.next = 9;
                return this.buildToken(tokenInfo);

              case 9:
                token = _context2.sent;
                return _context2.abrupt("return", token);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTokenBySymbol(_x2) {
        return _getTokenBySymbol.apply(this, arguments);
      }

      return getTokenBySymbol;
    }()
  }, {
    key: "getTokenByAddress",
    value: function () {
      var _getTokenByAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(address) {
        var tokenInfo, token;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.chainAddressToTokenInfo[this.chainId.toString()]) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", undefined);

              case 2:
                tokenInfo = this.chainAddressToTokenInfo[this.chainId.toString()][address.toLowerCase()];

                if (tokenInfo) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", undefined);

              case 5:
                _context3.next = 7;
                return this.buildToken(tokenInfo);

              case 7:
                token = _context3.sent;
                return _context3.abrupt("return", token);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTokenByAddress(_x3) {
        return _getTokenByAddress.apply(this, arguments);
      }

      return getTokenByAddress;
    }()
  }, {
    key: "buildToken",
    value: function () {
      var _buildToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(tokenInfo) {
        var cacheKey, cachedToken, token;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                cacheKey = this.CACHE_KEY(tokenInfo);
                _context4.next = 3;
                return this.tokenCache.get(cacheKey);

              case 3:
                cachedToken = _context4.sent;

                if (!cachedToken) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return", cachedToken);

              case 6:
                token = new Token(this.chainId, tokenInfo.address, tokenInfo.decimals, tokenInfo.symbol, tokenInfo.name);
                _context4.next = 9;
                return this.tokenCache.set(cacheKey, token);

              case 9:
                return _context4.abrupt("return", token);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function buildToken(_x4) {
        return _buildToken.apply(this, arguments);
      }

      return buildToken;
    }()
  }], [{
    key: "fromTokenListURI",
    value: function () {
      var _fromTokenListURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(chainId, tokenListURI, tokenCache) {
        var now, tokenList;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                now = Date.now();
                _context5.next = 3;
                return this.buildTokenList(tokenListURI);

              case 3:
                tokenList = _context5.sent;
                metric.putMetric('TokenListLoad', Date.now() - now, MetricLoggerUnit.Milliseconds);
                return _context5.abrupt("return", new CachingTokenListProvider(chainId, tokenList, tokenCache));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fromTokenListURI(_x5, _x6, _x7) {
        return _fromTokenListURI.apply(this, arguments);
      }

      return fromTokenListURI;
    }()
  }, {
    key: "buildTokenList",
    value: function () {
      var _buildTokenList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(tokenListURI) {
        var response, tokenList, status;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                log.info("Getting tokenList from ".concat(tokenListURI, "."));
                _context6.next = 3;
                return axios.get(tokenListURI);

              case 3:
                response = _context6.sent;
                log.info("Got tokenList from ".concat(tokenListURI, "."));
                tokenList = response.data, status = response.status;

                if (!(status != 200)) {
                  _context6.next = 9;
                  break;
                }

                log.error({
                  response: response
                }, "Unabled to get token list from ".concat(tokenListURI, "."));
                throw new Error("Unable to get token list from ".concat(tokenListURI));

              case 9:
                return _context6.abrupt("return", tokenList);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function buildTokenList(_x8) {
        return _buildTokenList.apply(this, arguments);
      }

      return buildTokenList;
    }()
  }, {
    key: "fromTokenList",
    value: function () {
      var _fromTokenList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(chainId, tokenList, tokenCache) {
        var now, tokenProvider;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                now = Date.now();
                tokenProvider = new CachingTokenListProvider(chainId, tokenList, tokenCache);
                metric.putMetric('TokenListLoad', Date.now() - now, MetricLoggerUnit.Milliseconds);
                return _context7.abrupt("return", tokenProvider);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function fromTokenList(_x9, _x10, _x11) {
        return _fromTokenList.apply(this, arguments);
      }

      return fromTokenList;
    }()
  }]);

  return CachingTokenListProvider;
}();